import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { isSeatPaymentFailedError, seatPaymentFailedMessage, } from '#pplx/frontend/apps/ask/organization/utils/seatPaymentError.js';
import { defineMessage } from 'react-intl';
export const seatCancellationMessage = defineMessage({
    defaultMessage: 'Your subscription is scheduled to cancel. Resume your subscription before making this seat change.',
    id: '6d36d6f2d0',
    description: 'Recovery guidance when an Enterprise seat change is blocked by pending cancellation',
});
export const isSeatCancellationError = (error) => error instanceof ApiClientsError &&
    error.detail?.error_code === 'subscription_pending_cancellation';
const seatCapacityUnavailableMessage = defineMessage({
    defaultMessage: 'We couldn’t load your seat or pricing details. Try again.',
    id: 'dad7792c64',
    description: 'Error when live Enterprise seat capacity or a billing quote is unavailable',
});
/** Shared copy for seat failures; callers retain their own fallback and workflow. */
export const getSeatChangeErrorMessage = (error) => {
    if (isSeatPaymentFailedError(error))
        return seatPaymentFailedMessage;
    if (isSeatCancellationError(error))
        return seatCancellationMessage;
    if (error instanceof ApiClientsError &&
        error.detail?.error_code === 'seat_capacity_unavailable') {
        return seatCapacityUnavailableMessage;
    }
    return null;
};
//# sourceMappingURL=seatChangeError.js.map